import script from "./ZAccordionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ZAccordionItem.vue?vue&type=script&setup=true&lang=js"

import "./ZAccordionItem.vue?vue&type=style&index=0&id=8bf0dd0a&lang=scss"

const __exports__ = script;

export default __exports__